import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[IoT Dashboard] UI error:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            background: "#1f1f24",
            color: "#f8fafc",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          <div style={{ maxWidth: 640 }}>
            <h1 style={{ margin: "0 0 12px", fontSize: 22 }}>Dashboard failed to load</h1>
            <p style={{ margin: "0 0 16px", color: "#cbd5e1", lineHeight: 1.5 }}>
              The IoT dashboard hit a JavaScript error while loading the new shared UI shell. Check the browser
              console (F12) for details, then reload. If you just pulled code, run{" "}
              <code style={{ color: "#f8fafc" }}>npm start</code> from <code>iot-dashboard</code> again.
            </p>
            <pre
              style={{
                margin: 0,
                padding: 12,
                borderRadius: 8,
                background: "#2a2a32",
                fontSize: 12,
                overflow: "auto",
                whiteSpace: "pre-wrap",
              }}
            >
              {String(this.state.error?.message || this.state.error)}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
